import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";

import Etapas from "../../../Components/CardsPages/Etapas";
import AtendimentoDetalhado from "../../../Components/CardsPages/Atendimento/AtendimentoDetalhado";

import {
    AtendimentoPageProvider,
    useAtendimentoPage,
} from "../../../Context/AtendimentoPage";

import "../../../Assets/css/pages/placeholder.css";
import {
    // faEnvelope,
    faPaperPlane,
    faSearchDollar,
} from "@fortawesome/free-solid-svg-icons";
// import EnvelopesGerados from "../EnvelopesGerados";
// import { faFile } from "@fortawesome/free-solid-svg-icons";
// import ContratosGeradosCard from "../../../Components/CardsPages/ContratosGerados";
import AnaliseCredito from "../../../Components/CardsPages/AnaliseCredito";
import Proposta from "../../../Components/CardsPages/Proposta";
import { IAtendimentoExtraDetalhado } from "../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";
import AcoesVendas from "./AcoesVendas";
import { useUserInfor } from "../../../Context/User";
import StatusEtapa from "../../../Components/CardsPages/StatusEtapa";
import { useModuloInfo } from "../../../Context/ModuloInfo";
import { ACESSOS } from "../../../Routes/Acessos";

interface IRouteParams {
    IDCaso: string;
}
interface IVendasPageProps {
    IDCaso: number;
}

export default function AtendimentoVendas() {
    const params = useParams<IRouteParams>();
    const idCaso = Number.parseInt(params.IDCaso);

    return (
        <AtendimentoPageProvider ID_CASO={idCaso}>
            <VendasPage IDCaso={idCaso} />
        </AtendimentoPageProvider>
    );
}

function VendasPage(props: IVendasPageProps) {
    const AtendimentoPage = useAtendimentoPage();
    const Atendimento = AtendimentoPage.Atendimento!;

    const { id } = useModuloInfo();

    const [activeTab, setActiveTab] = useState<string | undefined>("#unidades");

    const [bloquearAcoes, setBloquearAcoes] = useState(false);

    const { ID_USUARIO } = useUserInfor().UserInfor;
    const { UserInfor } = useUserInfor();

    const AtendimentoExtraDetalhado = useAtendimentoPage()
        .Atendimento as IAtendimentoExtraDetalhado;

    const extraTabs = useMemo(() => {
        const extraTabs: any[] = [
            // {
            //     key: "#envelopesGerados",
            //     name: "Envelopes Gerados",
            //     icon: faEnvelope,
            //     Component: () => <EnvelopesGerados />,
            // },
            // {
            //     key: "#contratosGerados",
            //     name: "Contratos Gerados",
            //     icon: faFile,
            //     Component: () => (
            //         <ContratosGeradosCard ID_CASO={props.IDCaso} />
            //     ),
            // },
            // ID_ETAPA_TIPO_CASO === Analise de credito
            AtendimentoExtraDetalhado.ID_ETAPA_TIPO_CASO >= 25
                ? {
                      key: "#analiseCredito",
                      name: "Análise de Crédito",
                      icon: faSearchDollar,
                      Component: () => (
                          <AnaliseCredito ID_CASO={props.IDCaso} />
                      ),
                  }
                : null,
            // ID_ETAPA_TIPO_CASO === Proposta
            AtendimentoExtraDetalhado.ID_ETAPA_TIPO_CASO >= 26
                ? {
                      key: "#proposta",
                      name: "Proposta",
                      icon: faPaperPlane,
                      Component: () => <Proposta ID_CASO={props.IDCaso} />,
                  }
                : null,
        ].filter(Boolean);

        if (AtendimentoExtraDetalhado.ID_ETAPA_TIPO_CASO === 26) {
            setActiveTab("#proposta");
        } else if (AtendimentoExtraDetalhado.ID_ETAPA_TIPO_CASO === 25) {
            setActiveTab("#analiseCredito");
        } else if (AtendimentoExtraDetalhado.ID_ETAPA_TIPO_CASO === 24) {
            setActiveTab("#docs");
        } else if (ACESSOS.VENDAS.ID_MODULO === id) {
            setActiveTab("#produtoInteresse");
        } else {
            setActiveTab("#unidades");
        }

        return extraTabs;
    }, [AtendimentoExtraDetalhado.ID_ETAPA_TIPO_CASO, id, props.IDCaso]);

    return (
        <>
            {Atendimento ? (
                <>
                    <div className="col-12 mb-5">
                        <Etapas
                            ID_CATEGORIA={0}
                            ID_ETAPA={Atendimento.ID_ETAPA_TIPO_CASO}
                            finalizado={!!Atendimento.DT_FIM}
                        />
                    </div>
                    {
                        <AtendimentoDetalhado
                            IDCaso={props.IDCaso}
                            Atendimento={Atendimento}
                            extraTabs={extraTabs}
                            buttons={<></>}
                            activeTab={activeTab}
                            setActiveTab={setActiveTab}
                            adicionalComponent={
                                (!AtendimentoPage.bloquearInteracoes &&
                                    Atendimento.ID_USUARIO_RESPONSAVEL ===
                                        ID_USUARIO) ||
                                UserInfor.FUNCOES.some(
                                    (f) =>
                                        f.NM_FUNCAO ===
                                        "ADM_PERMITE_ACOES_TELA_ATENDIMENTO"
                                ) ? (
                                    <>
                                        {!Atendimento.DT_FIM && (
                                            <>
                                                <StatusEtapa
                                                    idEtapaTipoCaso={
                                                        Atendimento.ID_ETAPA_TIPO_CASO
                                                    }
                                                    setBloquearAcoes={
                                                        setBloquearAcoes
                                                    }
                                                    idCaso={props.IDCaso}
                                                />

                                                <AcoesVendas
                                                    bloquearAcoes={
                                                        bloquearAcoes
                                                    }
                                                />
                                            </>
                                        )}
                                    </>
                                ) : (
                                    ""
                                )
                            }
                        />
                    }
                </>
            ) : (
                <div className="text-muted text-center">
                    Atendimento não encontrado
                </div>
            )}
        </>
    );
}
